<vi-sidenav data-at-slide-bar (close)="trackClose()">
  <div
    userInfo
    *ngIf="authStore.me$ | async as me"
    gtm="onRedirect"
    gtmAction="Customer self service"
    gtmCategory="sidenav"
    (click)="goToProfilePage()"
    class="user-info flex flex-row gap-[12px]"
  >
    <div class="flex flex-col">
      <div class="user-initials-avatar flex-[50px] max-w-[50px]">
        <vi-user-avatar [userInfo]="me"></vi-user-avatar>
      </div>
    </div>
    <div class="flex flex-col justify-center items-start">
      <div data-at-user-name class="user-name">{{ me?.firstName }} {{ me?.familyName }}</div>
    </div>
  </div>
  <ul top class="menu flex-[100%] max-w-[100%]">
    <ng-container *appHideForRsaUser>
      <ng-container *ngIf="!(authStore.isEndUser$ | async)">
        <li *appForCommercialUser="false" data-at-menu-item data-at-bar-home class="menu-item">
          <a
            class="link flex flex-row gap-[12px]"
            gtm="onGoToPage"
            gtmAction="Dashboard"
            gtmCategory="sidenav"
            [routerLink]="['/dashboard']"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            <div data-at-installation-overview class="title">
              {{ 'SHARED.SIDENAV.DASHBOARD' | translate }}
            </div>
            <img class="icon" icon src="/assets/icons/arrow-right.svg" />
          </a>
        </li>
      </ng-container>
    </ng-container>
  </ul>
  <ul top class="menu strong flex-[100%] max-w-[100%]">
    <li
      *appForCommercialUser="false"
      data-at-menu-item
      data-at-bar-installations-board
      class="menu-item"
    >
      <!-- Disabled explicitly for /installations and /installations/board if kanban is a default link -->
      <a
        class="link flex flex-row gap-[20px] justify-start items-center"
        gtm="onGoToPage"
        gtmAction="KanbanBoard"
        gtmCategory="sidenav"
        [routerLink]="[deviceMonitoringLink]"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [class.active]="router.url === '/installations'"
      >
        <div data-at-kanban-board class="title">
          {{ getInstallationsLinkLabel() }}
        </div>
        <img class="icon" icon src="/assets/icons/arrow-right.svg" />
      </a>
    </li>
    <li data-at-menu-item *appHideForRsaUser class="menu-item">
      <a
        *ngIf="bookingStore.hasAccessToBooking$ | async"
        class="link flex flex-row gap-[20px] justify-start items-center"
        gtm="onGoToPage"
        gtmAction="Booking overview"
        gtmCategory="sidenav"
        [routerLink]="['/booking-overview']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div data-at-booking-overview data-at-bar-booking-overview class="title">
          {{ 'SHARED.SIDENAV.BOOKING_OVERVIEW' | translate }}
        </div>
        <img class="icon" icon src="/assets/icons/arrow-right.svg" />
      </a>
    </li>
    <li
      data-at-menu-item
      data-at-menu-item-booking
      *ngIf="bookingStore.hasAccessToBooking$ | async"
      class="menu-item"
    >
      <a
        class="link flex flex-row gap-[20px] justify-start items-center"
        gtm="onGoToPage"
        gtmAction="Booking"
        gtmCategory="sidenav"
        [routerLink]="['/booking']"
        [class.active]="isBookingActive()"
      >
        <div data-at-booking data-at-bar-booking class="title">
          {{ 'SHARED.SIDENAV.BOOKING' | translate }}
        </div>
        <img class="icon" icon src="/assets/icons/arrow-right.svg" />
      </a>
    </li>
  </ul>

  <ul middle class="menu strong">
    <ng-container *ngIf="authStore.userHasAccessToInvitations() | async">
      <li *appForCommercialUser="false" data-at-menu-item class="menu-item">
        <a
          class="link flex flex-row gap-[20px] justify-start items-center"
          gtm="onGoToPage"
          gtmAction="Invitations"
          gtmCategory="sidenav"
          [routerLink]="['/invitations']"
          routerLinkActive="active"
        >
          <div data-at-invitations data-at-bar-invitations class="title">
            {{ 'SHARED.SIDENAV.INVITATIONS' | translate }}
          </div>
          <img class="icon" icon src="/assets/icons/arrow-right.svg" />
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="!(authStore.isEndUser$ | async)">
      <li data-at-menu-item data-at-menu-item-assistant class="menu-item">
        <a
          class="link flex flex-row gap-[20px] justify-start items-center"
          gtm="onGoToPage"
          gtmAction="Assistant"
          gtmCategory="sidenav"
          [routerLink]="['/assistant']"
          routerLinkActive="active"
        >
          <div data-at-assistant class="title">{{ 'SHARED.SIDENAV.ASSISTANT' | translate }}</div>
          <img class="icon" icon src="/assets/icons/arrow-right.svg" />
        </a>
      </li>
    </ng-container>

    <li *appForCommercialUser="false" data-at-menu-item class="menu-item">
      <a
        class="link flex flex-row justify-between"
        gtm="onGoToPage"
        gtmAction="Updates"
        gtmCategory="sidenav"
        [routerLink]="['/updates']"
        routerLinkActive="active"
      >
        <div class="link flex flex-row gap-[20px] justify-start items-center">
          <div data-at-updates class="title">{{ 'SHARED.SIDENAV.UPDATES' | translate }}</div>
          <img class="icon" icon src="/assets/icons/arrow-right.svg" />
        </div>
      </a>
    </li>
    <ng-container *appHideForRsaUser>
      <ng-container *ngIf="!(authStore.isEndUser$ | async)">
        <li *appForCommercialUser="false" data-at-menu-item class="menu-item">
          <a
            class="link flex flex-row gap-[20px] justify-start items-center"
            gtm="onGoToPage"
            gtmAction="LearningCenter"
            gtmCategory="sidenav"
            (click)="openLearningCenterModal()"
          >
            <div data-at-learning-center class="title">
              {{ 'SHARED.SIDENAV.LEARNING_CENTER' | translate }}
            </div>
            <img class="icon" icon src="/assets/icons/arrow-right.svg" />
          </a>
        </li>
      </ng-container>
    </ng-container>
  </ul>

  <ul bottom class="menu flex-[100%] max-w-[100%]">
    <li data-at-menu-item data-at-settings class="menu-item">
      <a
        class="link flex flex-row gap-[20px] justify-start items-center"
        gtm="onGoToPage"
        gtmAction="Settings"
        gtmCategory="sidenav"
        [routerLink]="['/settings']"
        routerLinkActive="active"
      >
        <div data-at-settings class="title">{{ 'SHARED.SIDENAV.SETTINGS' | translate }}</div>
        <img class="icon" icon src="/assets/icons/arrow-right.svg" />
      </a>
    </li>
    <ng-container
      *ngIf="gcStore.isGatewayCommissioningAvailable$ | async as isGatewayCommissioningAvailable"
    >
      <li
        *ngIf="
          !isGatewayCommissioningAvailable.isLoading && isGatewayCommissioningAvailable.isAvailable
        "
        data-at-menu-item
        class="menu-item"
      >
        <a
          class="link flex flex-row gap-[20px] justify-start items-center"
          gtm="onGoToPage"
          gtmAction="GatewayCommissioning"
          gtmCategory="sidenav"
          [routerLink]="['/commissioning']"
          routerLinkActive="active"
        >
          <div data-at-gateway-commissioning class="title">
            {{ 'SHARED.SIDENAV.WIFI_COMMISSIONING' | translate }}
          </div>
          <img class="icon" icon src="/assets/icons/arrow-right.svg" />
        </a>
      </li>
    </ng-container>
    <li data-at-menu-item class="menu-item">
      <a
        class="link flex flex-row justify-between items-stretch"
        gtm="onGoToPage"
        gtmAction="Legal information"
        gtmCategory="sidenav"
        [routerLink]="['/legal-information']"
        routerLinkActive="active"
      >
        <div class="flex flex-row gap-[20px] justify-start items-center">
          <div data-at-legal-info class="title">
            {{ 'SHARED.SIDENAV.LEGAL_INFORMATION' | translate }}
          </div>
          <img class="icon" icon src="/assets/icons/arrow-right.svg" />
        </div>
      </a>
    </li>
    <ng-container *ngIf="remoteConfigStore.isApplicationBetaVersionAvailable$ | async">
      <li data-at-menu-item class="menu-item">
        <a
          class="link flex flex-row justify-between items-stretch"
          gtm="onGoToPage"
          gtmAction="Beta Version"
          gtmCategory="sidenav"
          data-at-open-beta-app-version
          href="{{ APP_BETA_VERSION_URL }}"
          target="_blank"
        >
          <div class="flex flex-row gap-[20px] justify-start items-center">
            <div data-at-legal-info class="title">
              {{ 'SHARED.SIDENAV.APP_BETA_VERSION' | translate }}
            </div>
            <img class="icon" icon src="/assets/icons/arrow-right.svg" />
          </div>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="remoteConfigStore.isHeatingSystemsLinkVisibleInSideMenu$ | async">
      <ng-container *appHideForRsaUser>
        <li
          *ngIf="
            (authStore.primaryVkorg$ | async) &&
            (authStore.isUserWithHeatingSystemsOverviewRole$ | async) &&
            (remoteConfigStore.heatingSystemsAccess$ | async)?.registeredInstallations
          "
          data-at-menu-item
          class="menu-item"
        >
          <a
            class="link flex flex-row gap-[20px] justify-start items-center"
            gtm="onGoToPage"
            gtmAction="Heating systems iframe"
            gtmCategory="sidenav"
            [routerLink]="'/' + heatingSystemsLink"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div data-at-heating-systems class="title">
              {{ 'SHARED.SIDENAV.HEATING_SYSTEMS' | translate }}
            </div>
            <img class="icon" icon src="/assets/icons/arrow-right.svg" />
          </a>
        </li>
      </ng-container>
    </ng-container>
  </ul>
  <ul version class="menu">
    <li>
      <div data-at-version class="version">
        {{ 'SHARED.SIDENAV.VERSION' | translate }} {{ appVersion }}
      </div>
    </li>
  </ul>
</vi-sidenav>
